import React from "react";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import styles from "./TopBannerMessageNotifyForm.module.scss";
import { generateID } from "@digitallab/grid-common-components";
import { Module } from "../../../constants";
import TopBannerMessagePageAdmin from "./TopBannerMessagePageAdmin";

const { adminTopBannerMessage } = Module.PAGE.ADMIN;

const TopBannerMessageMainPage = () => {
  const { trackPageView } = useMatomo();
  React.useEffect(() => {
    trackPageView({
      documentTitle: "Admin/SendGroupNotify",
      href: `${window.location?.origin}/Admin/SendGroupNotify`
    });
    // eslint-disable-next-line
  }, []);
  return (
    <div
      className={styles.MainPageBox}
      data-testid="main-page-for-send-group-notify"
      id={generateID.UUID(adminTopBannerMessage, `topbanner`, "div_send_notify")}
    >
      <TopBannerMessagePageAdmin />
    </div>
  );
};

export default TopBannerMessageMainPage;
